// Mock data for NSTI clone landing page

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "How We Work", href: "#process" },
  { label: "Case Studies", href: "#cases" },
  { label: "Insights", href: "#insights" },
  { label: "Talent", href: "#talent" },
];

export const techBadges = [
  "AWS", "Azure", "GCP", "Kubernetes", "Terraform", "AIOps"
];

export const trustItems = [
  "Enterprise-Scale Distributed Systems",
  "Multi-Cloud Architecture Expertise",
  "High-Availability, Mission-Critical Platforms",
];

export const services = [
  {
    id: "aiops",
    title: "AIOps Framework Implementation",
    icon: "BrainCircuit",
    description: "Design and implement AI-driven operational platforms that automate monitoring, incident detection, and system optimization.",
    bullets: [
      "Event correlation and anomaly detection",
      "Observability pipelines and telemetry integration",
      "AWS-native AI services (Bedrock, analytics frameworks)",
    ],
  },
  {
    id: "multicloud",
    title: "Multi-Cloud Platform Engineering",
    icon: "CloudCog",
    description: "Architect and deploy scalable infrastructure across AWS, Azure, and GCP environments.",
    bullets: [
      "Kubernetes-based platform design (EKS, GKE)",
      "Secure networking, IAM, and system integration",
      "High-availability and fault-tolerant architectures",
    ],
  },
  {
    id: "iac",
    title: "Infrastructure Automation (Terraform)",
    icon: "Boxes",
    description: "Standardize and automate infrastructure delivery using Infrastructure-as-Code.",
    bullets: [
      "Terraform modules and reusable infrastructure patterns",
      "CI/CD-driven provisioning and deployment workflows",
      "Environment consistency and governance",
    ],
  },
  {
    id: "migration",
    title: "Cloud Migration & Modernization",
    icon: "Rocket",
    description: "Transform legacy systems into scalable, cloud-native platforms.",
    bullets: [
      "Migration strategy and execution",
      "Microservices and distributed system architecture",
      "Performance, cost, and reliability optimization",
    ],
  },
];

export const processSteps = [
  {
    number: "01",
    name: "Define",
    description: "We assess your current environment and define a clear architecture strategy aligned with business and technical goals.",
    items: [
      "Architecture reviews",
      "Technical roadmap development",
      "Solution design and planning",
    ],
  },
  {
    number: "02",
    name: "Build",
    description: "Our engineers embed directly into your workflows to deliver scalable, production-ready systems.",
    items: [
      "Platform engineering and implementation",
      "Infrastructure automation and CI/CD",
      "Cloud-native application enablement",
    ],
  },
  {
    number: "03",
    name: "Optimize",
    description: "We continuously improve performance, reliability, and operational efficiency.",
    items: [
      "Observability and monitoring",
      "AIOps and automation frameworks",
      "System performance tuning and cost optimization",
    ],
  },
];

export const techStack = [
  { icon: "Cloud", name: "AWS", detail: "EKS, Lambda, VPC, IAM, Bedrock" },
  { icon: "Workflow", name: "Terraform", detail: "Modular infrastructure, automation pipelines" },
  { icon: "Container", name: "Kubernetes", detail: "Container orchestration at scale" },
  { icon: "Activity", name: "Observability", detail: "Prometheus, CloudWatch, Splunk" },
  { icon: "Network", name: "Distributed Systems", detail: "Event-driven architectures" },
  { icon: "GitGraph", name: "Graph Systems", detail: "Graph-based modeling and data systems" },
];

export const caseStudies = [
  {
    tag: "Enterprise",
    title: "Enterprise Platform Build",
    description: "Designed and deployed multi-cloud infrastructure supporting distributed, high-volume workloads.",
    metrics: [
      { k: "Deployment consistency", v: "Terraform-automated" },
      { k: "System reliability", v: "Increased" },
      { k: "Workload scale", v: "High-volume" },
    ],
  },
  {
    tag: "AIOps",
    title: "Observability & AIOps Platform",
    description: "Implemented monitoring and alerting systems across complex distributed environments.",
    metrics: [
      { k: "Incident detection", v: "Enhanced" },
      { k: "Response times", v: "Improved" },
      { k: "Optimization", v: "Proactive" },
    ],
  },
];

export const insights = [
  {
    category: "AIOps",
    title: "Designing an AIOps Framework on AWS",
    excerpt: "A practical breakdown of building intelligent monitoring and automation systems using AWS services.",
    readTime: "8 min read",
  },
  {
    category: "Terraform",
    title: "Terraform Patterns for Multi-Account Environments",
    excerpt: "Best practices for managing infrastructure at scale across AWS organizations.",
    readTime: "6 min read",
  },
  {
    category: "Observability",
    title: "Improving Observability in Distributed Systems",
    excerpt: "How to align logs, metrics, and tracing for better operational visibility and performance.",
    readTime: "7 min read",
  },
];

export const talent = [
  {
    role: "Principal Cloud Architect",
    icon: "Crown",
    description: "Expert in AWS, multi-cloud architecture, and large-scale distributed systems.",
    focus: "Platform design, system scalability, and governance",
  },
  {
    role: "DevOps / Platform Engineer",
    icon: "Wrench",
    description: "Specialist in infrastructure automation, CI/CD, and Kubernetes platforms.",
    focus: "Terraform, pipelines, and operational efficiency",
  },
  {
    role: "Infrastructure Engineer",
    icon: "Server",
    description: "Deep expertise in networking, system reliability, and cloud operations.",
    focus: "Performance, observability, and production systems",
  },
];

export const footerLinks = {
  Services: [
    "AIOps Frameworks",
    "Platform Engineering",
    "Infrastructure Automation",
    "Cloud Migration",
  ],
  Resources: ["Engineering Insights", "Case Studies"],
  Company: ["About Us", "Contact"],
};

export const contact = {
  location: "Austin, TX",
  email: "kween.baker@nstinstitute.com",
  linkedin: "linkedin.com/in/kweenbaker",
};
